<template>
  <div id="add-user" class="m-t-10">
    <form action="#" v-on:submit.prevent="submitForm">
      <div class="form-group">
        <label for="input-nama">Query</label>
        <div class="row">
          <div class="col-md-10">
            <div class="form-group">
              <input
                type="text"
                name="nama"
                value=""
                id="input-query"
                class="form-control"
                placeholder=""
                v-model="q"
              />
            </div>
          </div>
          <div class="col-md-2">
            <a class="btn btn-lg btn-primary" @click="getData()"> Cari </a>
          </div>
        </div>
      </div>
      <div class="form-group">
        <table class="table table-bordered" id="beritatable">
          <thead>
            <tr>
              <th></th>
              <th width="50%">Judul</th>
              <th width="15%">Media</th>
              <th width="15%">Tanggal</th>
              <th width="5%">Link</th>
            </tr>
          </thead>
          <tbody v-for="(berita, index) in dataBerita" :key="index">
            <tr>
              <td>
                <input
                  id="checkboxBerita"
                  type="checkbox"
                  value="1"
                  :checked="checkData(berita._id.$oid)"
                  @change="clickCheckbox(berita._id.$oid)"
                />
              </td>
              <td>{{ berita.title }}</td>
              <td>{{ berita.account }}</td>
              <td>{{ dateindo(berita.date.$date) }}</td>
              <td>
                <a
                  :href="
                    berita.source == 'media_cetak' ||
                    berita.source == 'media_tv'
                      ? url + '/view?id=' + berita._id.$oid
                      : berita.url
                  "
                  target="_blank"
                  class="btn btn-primary"
                >
                  <i class="bi bi-box-arrow-up-right mr-1"></i> Kunjungi Berita
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="form-group">
        <pagination-component
          v-if="page_info != null"
          :key="pagination_key"
          class="pull-left"
          :data="page_info"
          :goto="true"
        />
      </div>
      <div class="form-group" align="right">
        <button type="button" class="btn btn-danger m-r-5" data-dismiss="modal">
          Batal
        </button>
        <button type="submit" class="btn btn-primary">Simpan</button>
      </div>
    </form>
  </div>
</template>

<script>
import $ from "jquery";
import notif from "@/assets/js/notif.js";
import gp from "@/plugins/generalPlugins.js";
import pagintaion_component from "@/views/components/pagination.vue";

$.pgNotification = notif;

export default {
  name: "AddStream",
  components: {
    "pagination-component": pagintaion_component,
  },
  props: {
    data: Array,
  },
  data() {
    return {
      q: null,
      id_project: this.$store.getters.user.id_project,
      dataBerita: {},
      page_info: null,
      pagination_key: 0,
      dataStream: [],
      url: window.location.origin,
    };
  },
  methods: {
    dateindo: function (tanggal) {
      return gp.dateTimeID(tanggal);
    },
    clickCheckbox: function (idStream) {
      var index = this.dataStream.indexOf(idStream);
      if (index != -1) {
        this.dataStream.splice(index, 1);
      } else {
        this.dataStream.push(idStream);
      }
    },
    checkData: function (idStream) {
      var index = this.dataStream.indexOf(idStream);
      let status = false;
      if (index != -1) {
        status = true;
      }
      return status;
    },
    getData: function () {
      let self = this;
      let params = {
        from: this.data[0].from,
        to: this.data[0].to,
      };

      if ("page" in this.$route.query) {
        params.page = this.$route.query.page;
      }
      if ("is_validated" in this.$route.query) {
        params.is_validated = this.$route.query.is_validated;
      }

      if (this.q != null) {
        params.q = btoa(this.q);
      }

      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      let api =
        process.env.VUE_APP_API_URL +
        "posts-dev/" +
        this.id_project +
        "?" +
        query;
      this.$http
        .get(api)
        .then(function (response) {
          if (response.status == 204) {
            self.dataBerita = {};
            self.page_info = null;
          } else {
            self.dataBerita = response.data.posts;
            self.page_info = response.data.page_info;
            self.pagination_key++;
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    submitForm: function () {
      if (this.dataStream.length > 0) {
        let params = {
          streams: this.$sanitize(this.dataStream),
          _id: this.data[0].idTrend,
        };
        let api = process.env.VUE_APP_API_URL + "newstrend/save-streams";
        this.$http
          .post(api, params)
          .then((response) => {
            if (response.status == 200) {
              this.$parent.$parent.getData();
              $("#modalStream").modal("hide");
              $("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Stream Trend berhasil ditambahkan!',
                  position: "top",
                  timeout: 5000,
                  type: "success",
                })
                .show();
            }
          })
          .catch(() => {
            $("#modalStream").modal("hide");
            $("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan pada saat menambahkan User!',
                position: "top",
                timeout: 5000,
                type: "danger",
              })
              .show();
          });
      } else {
        alert("Harap Memilih berita");
      }
    },
  },
  mounted: function () {
    this.dataStream = this.data[0].streams;
    this.getData();
  },
  watch: {
    $route() {
      this.getData();
    },
  },
};
</script>

<style scoped>
.form-control {
  -webkit-appearance: button;
}
select {
  cursor: pointer;
}
</style>